import logo from './decorcolorstintas-favicon.png';
import './App.css';
import { GoogleLogin } from '@react-oauth/google';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import { SuporteTiInit, SuporteTiInit2 } from './suporteTI';
import { SuporteRhInit, SuporteRhInit2 } from './suporteRH';

function Home() {

    let click1 = 0;
    let click2 = 0;
    let click3 = 0;

    const responseGoogle = (Response) => {

        let usuario = jwtDecode(Response.credential)

        if (usuario.hd == "decorcolors.com.br" ) {
            sessionStorage.setItem("email", usuario.email)
            sessionStorage.setItem("user", usuario.name)
            sessionStorage.setItem("dominio", usuario.hd)

            document.getElementById('Login').style.display = "none";
            document.getElementById('Menu').style.display = "flex";
        }
        else {
            alert("Acesso exclusivo para funcionários DecorColors")
        }
    }

    const SuporteTi = () => {

        if (click1 <= 2) {

            click1++
            var element = document.getElementsByTagName("script"), index;

            document.getElementById('Menu').style.display = "none";

            for (index = element.length - 1; index >= 1; index--) {
                element[index].parentNode.removeChild(element[index]);
            }

            window.NeoAssistTag = {}
            SuporteTiInit()
            SuporteTiInit2()

            // document.getElementById('suporteTI').style.backgroundColor = "#ff6666";
            // document.getElementById('manutencaoLoja').style.backgroundColor = "#ff0000";
            // document.getElementById('Sac').style.backgroundColor = "#ff0000";

            document.getElementById('divRender').style.display = "block";
            document.getElementById('voltar').style.display = "block";

        }
        else {

            window.location.reload()

        }

    }

    const SuporteRH = () => {

        if (click1 <= 2) {

            click1++
            var element = document.getElementsByTagName("script"), index;

            document.getElementById('Menu').style.display = "none";

            for (index = element.length - 1; index >= 1; index--) {
                element[index].parentNode.removeChild(element[index]);
            }

            window.NeoAssistTag = {}
            SuporteRhInit()
            SuporteRhInit2()

            // document.getElementById('suporteTI').style.backgroundColor = "#ff6666";
            // document.getElementById('manutencaoLoja').style.backgroundColor = "#ff0000";
            // document.getElementById('Sac').style.backgroundColor = "#ff0000";

            document.getElementById('divRender').style.display = "block";
            document.getElementById('voltar').style.display = "block";

        }
        else {

            window.location.reload()

        }

    }

    const reload = () => window.location.reload();

    return (
        <div className="App-header">

            <div className="login" id="Login" style={{ display: sessionStorage.getItem("email") == null ? 'block' : 'none' }}>

                <center><img src="logodecorcolors.png" /></center>

                <h4>
                    Bem Vindo!
                </h4>
                <p>
                    Clique no botão abaixo para realizar o seu login.
                </p>
                <div className='google'>
                    <GoogleOAuthProvider clientId="191918409592-8ki56pgle89o4oslnvto827qds1a08eq.apps.googleusercontent.com">
                        <GoogleLogin
                            buttonText='Continuar com o Google'
                            onSuccess={responseGoogle}
                            onFailure={responseGoogle}
                        />
                    </GoogleOAuthProvider>
                </div>
            </div>

            <div className="row" id="Menu" style={{ display: sessionStorage.getItem("email") != null ? 'flex' : 'none' }}>


                <div className="row">
                    <div className="options" onClick={SuporteTi}>
                        <button className="btnOpc ti glow"></button>
                        <center className="txtOpc glow">Suporte TI</center>
                    </div>
                   {/*
                    <div className="options" onClick={SuporteRH}>
                        <button className="btnOpc rh glow"></button>
                        <center className="txtOpc glow">RH - Atendimento</center>
                    </div>
                   */}
                </div>
            </div>


            <div id="voltar" style={{ display: 'none', position: 'absolute' }}>
                <h3 className='forceright' style={{ cursor: 'pointer' }} onClick={reload}>Voltar</h3>
            </div>

            <div id="divRender" style={{ display: 'none', width: "80%" }}>

            </div>

        </div>
    );
}


export default Home;
